import { HStack, Text, useToast } from "@chakra-ui/react";
import { WarnFillIcon } from "@micin-jp/icons";

import SvgCompletedGray from "src/components/icons/CompletedGray";
import SvgError from "src/components/icons/Error";
type Status = "success" | "error" | "warning";

export const useMomoToast = () => {
  const toast = useToast();

  const momoToast = ({
    status,
    description,
    marginTop,
  }: {
    status: Status;
    description: string;
    marginTop?: string;
  }) =>
    toast({
      position: "top",
      // NOTE: 医療機関側の成功メッセージのみ4秒間表示する。
      // https://micin.atlassian.net/browse/CURON-31551
      duration: status === "success" ? 4000 : 5000,
      containerStyle: {
        width: "100%",
        maxWidth: "initial",
        marginTop: marginTop || "48px",
        paddingLeft: "24px",
        paddingRight: "24px",
      },
      render: () => (
        <HStack bg={getBg(status)} h="48px" w="100%" borderRadius="4px" px="24px" fontWeight="bold">
          {renderIcon(status)}

          <Text fontSize="14px" color="white" whiteSpace="pre-wrap">
            {description}
          </Text>
        </HStack>
      ),
    });

  return momoToast;
};

const getBg = (status: Status) => {
  switch (status) {
    case "success":
      return "rgba(49, 53, 65, 0.8)";
    case "error":
      return "rgba(216, 30, 0, 0.75)";
    case "warning":
      return "rgba(224, 135, 0, 0.75)";
    default:
      const n: never = status;

      throw new Error(n);
  }
};

const renderIcon = (status: Status) => {
  switch (status) {
    case "success":
      return <SvgCompletedGray />;
    case "error":
      return <SvgError />;
    case "warning":
      return <WarnFillIcon color="#FFFFFF" width="20px" height="20px" />;
    default:
      const n: never = status;

      throw new Error(n);
  }
};
